// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1Hmf9ejuBvep9i {\n  cursor: pointer;\n  display: inline-block;\n  margin-bottom: 8px;\n  text-decoration: underline;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"showQrCodeLink": "_1Hmf9ejuBvep9i"
};
export default ___CSS_LOADER_EXPORT___;
